// removed by extract-text-webpack-plugin
module.exports = {"text-overlay":"_1to-eTdZzaM5splVKVBg62","textOverlay":"_1to-eTdZzaM5splVKVBg62","title":"_2XUNMbD3tnTPi9PancWzNt","text":"_1o3vE8wqD1WuQvQYsUmZrc","closeButton":"TcVtZl11pXBGserzvs8_x","header-image":"_25HFm8CJCQH2rZrt1A1y0p","headerImage":"_25HFm8CJCQH2rZrt1A1y0p","text-content":"_2AJpL00i3jcXr47Uj5AQXn","textContent":"_2AJpL00i3jcXr47Uj5AQXn"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/storydoc/book/overlays/textOverlay.css
// module id = 391
// module chunks = 0